<template>
  <div class="root-box">
    <div class="receipt-toolbar">
      <el-form size="small" :inline="true" class="receipt-filters" @submit.native.prevent>
        <el-form-item>
          <el-select style="width: 130px" v-model="param.invoiceType" placeholder="开票类型" @change="query()" clearable>
            <el-option v-for="item in receiptTypeOpts" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="param.state" clearable @change="query()" style="width: 130px" placeholder="开票状态">
            <el-option v-for="item in invoiceStateOpts" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-input v-model="param.companyName" placeholder="公司名称" clearable style="width: 140px"></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="param.passengerTel" placeholder="账户手机号" style="width: 140px" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-select v-model="param.defaultInvoice" clearable @change="query()" style="width: 130px"
            placeholder="只展示乘客申请">
            <el-option v-for="item in passengerInvoiceOpts" :key="String(item.value)" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="query()">查询</el-button>
        </el-form-item>
      </el-form>

      <div class="toolbar-actions">
        <div class="tax-group">
          <el-tag :type="eleLoginTagType" size="small">税务 {{ eleLogin.status || "未知" }}</el-tag>
          <el-dropdown trigger="click" @command="onTaxCommand">
            <el-button :size="size">
              税务操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="refresh">刷新状态</el-dropdown-item>
              <el-dropdown-item command="relogin">{{ eleReloginLabel }}</el-dropdown-item>
              <el-dropdown-item command="sms" :disabled="!eleLogin.needSmsCode">录入验证码</el-dropdown-item>
              <el-dropdown-item command="qrcode" :disabled="!eleLogin.needQrAuth">扫码认证</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-button type="primary" :size="size" @click="addReceipt">新增开票</el-button>
        <el-button :size="size" @click="downloadExcel">下载excel</el-button>
      </div>
    </div>

    <div class="table">
      <el-table :data="list" border stripe max-height="650" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" label="序号" show-overflow-tooltip width="50"></el-table-column>

        <el-table-column prop="stayRemark" label="特别注意" :width="120"></el-table-column>
        <el-table-column prop="state" label="上传状态" :width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.state | enumTransfer(invoiceStateOpts) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="发票张数" :width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.orderIdSet.length }}张</span>
          </template>
        </el-table-column>
        <el-table-column prop="passengerTel" label="账户" :width="120"></el-table-column>
        <el-table-column prop="invoiceType" label="开票类型" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.invoiceType | enumTransfer(receiptTypeOpts) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceFormat" label="开票格式" :width="90">
          <template slot-scope="scope">
            <span>{{ scope.row | invoiceFormatTransfer }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="公司名称" :width="180"></el-table-column>
        <el-table-column prop="taxNo" label="税号" :width="180"></el-table-column>

        <el-table-column prop="invoiceAmount" label="开票金额">
          <template slot-scope="scope">
            <span>{{ scope.row.invoiceAmount | moneyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="乘车人姓名" :width="120"></el-table-column>
        <el-table-column prop="expressNo" label="乘车人身份证号" :width="120"></el-table-column>

        <el-table-column prop="bank" label="开户行" width="130"></el-table-column>
        <el-table-column prop="bankAccount" label="开户行账号" :width="120"></el-table-column>
        <el-table-column prop="companyAddress" label="单位地址" width="200"></el-table-column>
        <el-table-column prop="companyPhone" label="单位电话"></el-table-column>
        <el-table-column prop="email" label="邮箱" width="160"></el-table-column>

        <el-table-column prop="createTime" label="申请时间" :width="160"></el-table-column>
        <el-table-column prop="msg" label="客服留言"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>

        <!-- <el-table-column prop="tel" label="收件电话"></el-table-column>
        <el-table-column prop="address" label="收件地址"></el-table-column> -->
        <!-- <el-table-column prop="status" label="支付状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status | enumTransfer(payStatusOpts) }}</span>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" fixed="right" :width="380">
          <template slot-scope="scope">
            <el-button type="text" size="small" :disabled="!scope.row.orderIds"
              @click="detailsQuery(scope.row.id)">查看详情</el-button>

            <el-button type="text" size="small" @click="msgSubmit(scope.row)">客服留言</el-button>
            <el-button type="text" size="small" @click="modifyInfo(scope.row)">修改信息</el-button>
            <el-button type="text" :style="{ color: scope.row.state === 2 ? '#606266' : '#409EFF' }" size="small"
              @click="upload(scope.row)">{{ scope.row.state === 1 ? "上传发票" : "重新上传" }}</el-button>
            <el-button type="text" size="small" :disabled="!scope.row.orderIdSet || !scope.row.orderIdSet.length"
              @click="reIssueAndSend(scope.row)">重新开票</el-button>
            <el-button type="text" size="small"
              :disabled="!scope.row.email || !scope.row.orderIdSet || !scope.row.orderIdSet.length || scope.row.defaultInvoice"
              @click="resendInvoiceMail(scope.row)">重新发送</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="订单详情" :visible.sync="travelTableVisible" width="1400px">
        <el-table :data="gridData" border>
          <el-table-column type="index" label="序号" width="50"></el-table-column>

          <el-table-column prop="path" label="路线" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.pathId | pathNameTransfer }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="date" label="日期" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.date }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="showTime" label="时间" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.showTime }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="number" label="人数" width="70">
            <template slot-scope="scope">
              <span v-if="!scope.row.editing">{{ scope.row.number }}</span>
              <el-input-number v-else v-model="scope.row.number" :min="1" :max="50" size="small"
                controls-position="right">
              </el-input-number>
            </template>
          </el-table-column>

          <el-table-column prop="price" label="客运费" width="100">
            <template slot-scope="scope">
              <span v-if="!scope.row.editing">{{ scope.row.price | moneyFormat }}元</span>
              <el-input-number v-else v-model="scope.row.price" :min="0" :precision="0" size="small"
                controls-position="right">
              </el-input-number>
            </template>
          </el-table-column>

          <el-table-column prop="seatFee" label="选座费" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.seatFee | moneyFormat }}元</span>
            </template>
          </el-table-column>

          <el-table-column prop="changeTimeFee" label="改签费" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.changeTimeFee | moneyFormat }}元</span>
            </template>
          </el-table-column>

          <el-table-column prop="refundFee" label="退票费" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.refundFee | moneyFormat }}元</span>
            </template>
          </el-table-column>

          <el-table-column prop="departure" label="起点" width="120">
            <template slot-scope="scope">
              <span v-if="!scope.row.editing">{{ scope.row.departure }}</span>
              <el-input v-else v-model="scope.row.departure" size="small"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="destination" label="终点" width="120">
            <template slot-scope="scope">
              <span v-if="!scope.row.editing">{{ scope.row.destination }}</span>
              <el-input v-else v-model="scope.row.destination" size="small"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="开票状态" width="160">
            <template slot-scope="scope">
              <div class="invoice-status-cell">
                <div v-if="scope.row.defaultFpqqlsh">
                  默认：
                  <el-tag v-if="scope.row.defaultSfych" size="mini" type="info">已冲红</el-tag>
                  <el-tag v-else-if="scope.row.defaultFphm" size="mini" type="success">已开</el-tag>
                  <el-tag v-else-if="scope.row.defaultFpqqlsh" size="mini" type="warning">开票中</el-tag>
                  <el-tag v-else size="mini" type="info">未开</el-tag>
                </div>
                <div v-if="scope.row.price > 0 || scope.row.fpqqlsh">
                  客运：
                  <el-tag v-if="scope.row.sfych" size="mini" type="info">已冲红</el-tag>
                  <el-tag v-else-if="scope.row.fphm" size="mini" type="success">已开</el-tag>
                  <el-tag v-else-if="scope.row.fpqqlsh" size="mini" type="warning">开票中</el-tag>
                  <el-tag v-else size="mini" type="info">未开</el-tag>
                </div>
                <div v-if="hasLifeFees(scope.row) || scope.row.lifeFpqqlsh">
                  服务：
                  <el-tag v-if="scope.row.lifeSfych" size="mini" type="info">已冲红</el-tag>
                  <el-tag v-else-if="scope.row.lifeFphm" size="mini" type="success">已开</el-tag>
                  <el-tag v-else-if="scope.row.lifeFpqqlsh" size="mini" type="warning">开票中</el-tag>
                  <el-tag v-else size="mini" type="info">未开</el-tag>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="420" fixed="right">
            <template slot-scope="scope">
              <span v-if="!scope.row.editing">
                <el-button type="text" size="small" @click="editOrder(scope.row)">编辑</el-button>
              </span>
              <span v-else>
                <el-button type="text" size="small" @click="saveOrder(scope.row)" style="color: #67c23a">保存</el-button>
                <el-button type="text" size="small" @click="cancelEdit(scope.row)">取消</el-button>
              </span>
              <el-button style="margin-left: 10px" type="text" size="small"
                @click="showTransaction(scope.row.id)">交易详情</el-button>
              <el-button type="text" size="small" v-goRouteDetail="scope.row.id">详情</el-button>
              <template v-if="scope.row.defaultFpqqlsh">
                <el-button type="text" size="small" @click="queryInvoiceResult(scope.row, 'DEFAULT')">默认开票</el-button>
              </template>
              <template v-if="scope.row.fpqqlsh">
                <el-button type="text" size="small" @click="queryInvoiceResult(scope.row, 'TRANSPORT')">客运开票</el-button>
              </template>
              <template v-if="scope.row.lifeFpqqlsh">
                <el-button type="text" size="small" @click="queryInvoiceResult(scope.row, 'LIFE')">服务开票</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :size="size" @click="travelTableVisible = false">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="invoiceResultTitle" :visible.sync="invoiceResultVisible" width="560px" @close="clearQrPoll">
        <el-descriptions v-if="invoiceResult" :column="1" border size="small">
          <el-descriptions-item label="票种">{{ invoiceResultPartLabel }}</el-descriptions-item>
          <el-descriptions-item label="返回码">{{ invoiceResult.code }}</el-descriptions-item>
          <el-descriptions-item label="描述信息">{{ invoiceResult.message }}</el-descriptions-item>
          <el-descriptions-item label="请求流水号">{{ invoiceResult.fpqqlsh }}</el-descriptions-item>
          <el-descriptions-item label="纳税人识别号">{{ invoiceResult.nsrsbh }}</el-descriptions-item>
          <el-descriptions-item label="发票代码">{{ invoiceResult.fpdm || "-" }}</el-descriptions-item>
          <el-descriptions-item label="发票号码">{{ invoiceResult.fphm || "-" }}</el-descriptions-item>
          <el-descriptions-item label="开票日期">{{ invoiceResult.kprq || "-" }}</el-descriptions-item>
          <el-descriptions-item label="是否已冲红">{{ invoiceResult.sfych || "-" }}</el-descriptions-item>
          <el-descriptions-item label="PDF地址">
            <a v-if="invoiceResult.pdfUrl" :href="invoiceResult.pdfUrl" target="_blank" rel="noopener">查看PDF</a>
            <span v-else>-</span>
          </el-descriptions-item>
        </el-descriptions>
        <div v-if="invoiceResult && invoiceResultAuthTip && invoiceResult.code === '1101'" class="result-action-tip">
          需重新登录税务账号后再开票，请在右上角「税务操作」中切换账号
        </div>
        <div v-else-if="invoiceResult && invoiceResultAuthTip && invoiceResult.code === '1102'"
          class="result-action-tip">
          需扫码完成实人认证，请在右上角「税务操作」中扫码认证
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :size="size" @click="invoiceResultVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="实人认证扫码" :visible.sync="qrAuthVisible" width="460px" :close-on-click-modal="false"
        @close="clearQrPoll">
        <div class="qr-auth-box" v-if="qrAuth">
          <p class="qr-auth-tip">{{ qrAuthTipText }}</p>
          <img v-if="qrAuth.qrImageBase64 && qrAuth.slzt !== '2'" :src="qrAuth.qrImageBase64" class="qr-auth-img"
            alt="认证二维码" />
          <p class="qr-auth-status">
            认证状态：
            <el-tag :type="qrStatusTagType" size="small">{{ qrAuthStatusText }}</el-tag>
          </p>
          <p class="qr-auth-sub" v-if="qrAuth.slzt === '1' || (!qrAuth.slzt && qrPolling)">
            请使用电子税局 / 个税 App 扫码完成实人认证，系统将自动检测结果
          </p>
          <p class="qr-auth-sub success-text" v-else-if="qrAuth.slzt === '2'">
            实人认证已通过，可关闭后重新开票或查询开票情况
          </p>
          <p class="qr-auth-sub danger-text" v-else-if="qrAuth.slzt === '3'">
            扫码超时，请点击下方按钮重新获取二维码后再扫码
          </p>
          <p class="qr-auth-sub" v-if="qrPolling && qrAuth.slzt !== '2' && qrAuth.slzt !== '3'">
            正在轮询认证结果...
          </p>
          <div class="qr-auth-actions">
            <el-button v-if="!qrAuth.qrImageBase64 || qrAuth.slzt === '3'" type="warning" :size="size"
              @click="refreshQrCode">获取二维码</el-button>
            <el-button v-if="qrAuth.qrImageBase64 && (qrAuth.slzt === '1' || !qrAuth.slzt)" type="primary" :size="size"
              @click="refreshQrCode">刷新二维码</el-button>
            <el-button v-if="qrAuth.slzt === '2'" type="success" :size="size" @click="closeQrAuth">认证完成</el-button>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button :size="size" @click="refreshQrCode">重新获取二维码</el-button>
          <el-button type="primary" :size="size" @click="closeQrAuth">关 闭</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="page">
      <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" background
        layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

    <el-dialog :title="form.id ? '修改信息' : '新增开票'" :visible.sync="formVisible" width="600px" max-height="600"
      :size="size" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :size="size" label-width="120px" :rules="rules">
        <el-form-item label="账户：" prop="passengerTel" clearable>
          <el-input v-model="form.passengerTel"></el-input>
        </el-form-item>
        <el-form-item label="开票类型：" prop="invoiceType">
          <el-select v-model="form.invoiceType" style="width: 100%">
            <el-option v-for="item in receiptTypeOpts" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="名称：" prop="companyName">
          <el-input v-model="form.companyName" placeholder="个人或者公司名称" clearable></el-input>
        </el-form-item>

        <el-form-item label="税号：" prop="taxNo">
          <el-input v-model="form.taxNo" placeholder="个人票无需填写税号" clearable></el-input>
        </el-form-item>

        <el-form-item label="乘车人姓名：" prop="name">
          <el-input v-model="form.name" clearable></el-input>
        </el-form-item>

        <el-form-item label="身份证号码：" prop="expressNo">
          <el-input v-model="form.expressNo" clearable></el-input>
        </el-form-item>

        <el-form-item label="邮箱：" prop="email">
          <el-input v-model="form.email" clearable></el-input>
        </el-form-item>
        <el-form-item label="开户行：" prop="bank">
          <el-input v-model="form.bank" clearable></el-input>
        </el-form-item>
        <el-form-item label="开户行账号：" prop="bankAccount">
          <el-input v-model="form.bankAccount" clearable></el-input>
        </el-form-item>
        <el-form-item label="单位地址：" prop="companyAddress">
          <el-input v-model="form.companyAddress" clearable></el-input>
        </el-form-item>
        <el-form-item label="单位电话：" prop="companyPhone">
          <el-input v-model="form.companyPhone" clearable></el-input>
        </el-form-item>
        <el-form-item label="保留备注：" prop="stayRemark">
          <el-input v-model="form.stayRemark" clearable></el-input>
        </el-form-item>
        <el-form-item label="开票格式：" prop="invoiceFormats">
          <el-select v-model="form.invoiceFormats" multiple placeholder="请选择开票格式" style="width: 100%" clearable>
            <el-option v-for="item in invoiceFormatOpts" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="saveOrUpdate">保 存</el-button>
        <el-button type="info" :size="size" @click="closeDialog">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="上传发票" :visible.sync="uploadVisible" width="600px" max-height="600" :size="size"
      :close-on-click-modal="false">
      <el-form :model="form">
        <div style="margin: 10px 0">发送给：{{ form.companyName }} - {{ form.name }}</div>
        <el-form-item label="电子发票：">
          <!-- <file-upload ref="uploader" v-model="form.invoiceUrl" filePath="/passenger/invoice" /> -->

          <el-upload class="upload-demo" ref="uploadRef" action="/admin/invoice/upload/invoice"
            :on-success="handleSuccess" :on-error="handleError" :on-progress="handleProgress" :on-change="handleChange"
            :data="extraData" drag name="files" :auto-upload="false" multiple>
            <slot>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </slot>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="onUpload">保 存</el-button>
        <el-button type="info" :size="size" @click="uploadVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择税务账号" :visible.sync="eleAccountVisible" width="420px" :close-on-click-modal="false">
      <el-form size="small" label-width="80px">
        <el-form-item label="登录账号">
          <el-select v-model="eleSelectedAccount" placeholder="请选择账号" style="width: 100%" filterable>
            <el-option v-for="item in eleAccountList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" :size="size" @click="confirmEleAccountLogin">登 录</el-button>
        <el-button :size="size" @click="eleAccountVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listReceipt,
  listDetails,
  addReceipt,
  modifyReceipt,
  modifyInvoiceOrder,
  delInvoiceOrder,
  getEleLoginStatus,
  getEleLoginAccounts,
  logoutEleLogin,
  startEleLogin,
  submitEleLoginSms,
  queryEleInvoiceResult,
  reIssueAndSendInvoice,
  resendInvoice,
  getEleQrCode,
  queryEleQrCodeStatus,
} from "@/api";
import { mapState } from "vuex";
import { ParamUtil } from "@/util";
import { downloadFile, uploadFiles } from "@/util/http";
import _ from "lodash";
import { BaseDataService } from "@/service";
import EventBus from "@/core/event/event-bus";
import { ELE_INVOICE_AUTH_REQUIRED } from "@/core/const/global-event";
const telReg = /^1\d{10}$/;

export default {
  created() {
    this.query();
    this.loadEleLoginStatus();
    EventBus.$on(ELE_INVOICE_AUTH_REQUIRED, this.onEleInvoiceAuthRequired);
  },
  beforeDestroy() {
    this.clearQrPoll();
    EventBus.$off(ELE_INVOICE_AUTH_REQUIRED, this.onEleInvoiceAuthRequired);
  },
  computed: {
    ...mapState({
      size: (state) => state.btnSize,
      payStatusOpts: (state) => state.enumMap["PAY_STATUS"],
      invoiceStateOpts: (state) => state.enumMap["INVOICE_STATE"]
    }),
    eleLoginTagType() {
      if (this.eleLogin.needQrAuth) {
        return "warning";
      }
      if (this.eleLogin.loggedIn) {
        return "success";
      }
      if (this.eleLogin.needSmsCode) {
        return "warning";
      }
      return "info";
    },
    eleReloginLabel() {
      if (this.eleLogin.loggedIn) {
        return "切换账号";
      }
      if (this.eleLogin.lastErrorCode === "1101" || (this.eleLogin.status || "").indexOf("重新登录") >= 0) {
        return "重新登录";
      }
      return "税务登录";
    },
    qrStatusTagType() {
      const slzt = this.qrAuth && this.qrAuth.slzt;
      if (slzt === "2") {
        return "success";
      }
      if (slzt === "3") {
        return "danger";
      }
      if (slzt === "1") {
        return "warning";
      }
      return "info";
    },
    qrAuthStatusText() {
      return this.resolveSlztText(this.qrAuth && this.qrAuth.slzt, this.qrAuth && this.qrAuth.slztText);
    },
    qrAuthTipText() {
      const slzt = this.qrAuth && this.qrAuth.slzt;
      if (slzt === "2") {
        return "实人认证已完成";
      }
      if (slzt === "3") {
        return "认证超时，请重新获取二维码扫码";
      }
      return "需完成实人认证后才能继续开票，请扫码认证";
    },
    invoiceResultTitle() {
      if (this.invoiceResultPart === "LIFE") {
        return "开票情况（生产生活服务）";
      }
      if (this.invoiceResultPart === "DEFAULT") {
        return "开票情况（默认票）";
      }
      return "开票情况（客运服务）";
    },
    invoiceResultPartLabel() {
      if (this.invoiceResultPart === "LIFE") {
        return "生产生活服务票";
      }
      if (this.invoiceResultPart === "DEFAULT") {
        return "默认票";
      }
      return "客运服务票";
    }
  },

  filters: {
    invoiceFormatTransfer(item) {
      if (item.invoiceFormats && item.invoiceFormats.length > 0) {
        return item.invoiceFormats.join("、");
      }
      return "";
    }
  },
  data() {
    return {
      param: {
        // 是否乘客票：是=非默认开票(defaultInvoice=false)
        defaultInvoice: false
      },
      invoiceFormatOpts: ["XML", "PDF", "OFD"],
      receiptTypeOpts: [
        { label: "对公", value: 1 },
        { label: "对私", value: 2 }
      ],
      receiptStatus: [
        { label: "已开", value: true },
        { label: "未开", value: false }
      ],
      // 乘客票：是→defaultInvoice=false；否→defaultInvoice=true
      passengerInvoiceOpts: [
        { label: "是", value: false },
        { label: "否", value: true }
      ],
      yesNoOpts: BaseDataService.yesNoOpts(),
      form: {},
      list: [],
      uploadVisible: false,
      pageSize: 30,
      currentPage: 1,
      total: 0,
      travelTableVisible: false,
      gridData: [],
      currentInvoiceId: null,
      invoiceResultVisible: false,
      invoiceResult: null,
      /** 是否展示「需重新登录/扫码」引导（开具实时鉴权失败为 true；查询历史失败原因为 false） */
      invoiceResultAuthTip: false,
      invoiceResultPart: "transport",
      qrAuthVisible: false,
      qrAuth: null,
      qrPolling: false,
      qrPollTimer: null,
      qrNsrsbh: null,
      eleLogin: {
        loggedIn: false,
        needSmsCode: false,
        needQrAuth: false,
        status: "未登录"
      },
      eleAccountVisible: false,
      eleAccountList: [],
      eleSelectedAccount: "",
      rules: {
        passengerTel: [
          { required: true, message: "账户不能为空", trigger: "blur" },
          {
            pattern: telReg,
            message: "请输入正确的手机号码",
            trigger: "change"
          }
        ],
        invoiceType: [{ required: true, message: "开票类型不能为空", trigger: "blur" }],
        remark: [{ required: true, message: "请备注路线", trigger: "blur" }],
      },
      formVisible: false,
      extraData: {},
      selectOrderIds: []
    };
  },
  methods: {
    loadEleLoginStatus() {
      getEleLoginStatus().then((res) => {
        this.eleLogin = res.data || {
          loggedIn: false,
          needSmsCode: false,
          needQrAuth: false,
          status: "未登录"
        };
      });
    },
    onTaxCommand(command) {
      if (command === "refresh") {
        this.loadEleLoginStatus();
      } else if (command === "relogin") {
        this.onReEleLogin();
      } else if (command === "sms") {
        this.onSubmitSmsCode();
      } else if (command === "qrcode") {
        this.openQrAuth();
      }
    },
    onReEleLogin() {
      logoutEleLogin().then(() => {
        this.loadEleLoginStatus();
        this.openEleAccountDialog();
      });
    },
    openEleAccountDialog() {
      getEleLoginAccounts().then((res) => {
        this.eleAccountList = res.data || [];
        this.eleSelectedAccount = this.eleAccountList[0] || "";
        if (!this.eleAccountList.length) {
          this.$message.warning("暂无可用税务账号");
          return;
        }
        this.eleAccountVisible = true;
      });
    },
    confirmEleAccountLogin() {
      if (!this.eleSelectedAccount) {
        this.$message.warning("请选择税务账号");
        return;
      }
      startEleLogin(this.eleSelectedAccount).then((res) => {
        const result = res.data || {};
        if (result.success) {
          this.$message.success("税务登录成功");
        } else if (result.needSmsCode) {
          this.$message.warning("验证码已发送，请在「税务操作」中录入验证码");
        } else {
          this.$message.warning("登录未完成，请稍后重试");
        }
        this.eleAccountVisible = false;
        this.loadEleLoginStatus();
      });
    },
    onSubmitSmsCode() {
      this.$prompt("请输入税务登录短信验证码", "录入验证码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d{4,8}$/,
        inputErrorMessage: "请输入正确的验证码",
        closeOnClickModal: false
      })
        .then(({ value }) => {
          return submitEleLoginSms(value);
        })
        .then((res) => {
          const result = res.data || {};
          if (result.success) {
            this.$message.success("税务登录成功");
          } else if (result.needSmsCode) {
            this.$message.warning("仍需验证码，请重新录入");
          } else {
            this.$message.warning("登录未完成，请稍后重试");
          }
          this.loadEleLoginStatus();
        })
        .catch(() => { });
    },
    query(page = 1, param = this.param || {}) {
      const query = {
        page: {
          current: page,
          size: this.pageSize
        },
        param: ParamUtil.filterEmptyData(param)
      };
      listReceipt(query).then((res) => {
        const { records = [], current = 1, total = 0 } = res.data || {};
        this.list = records;
        this.currentPage = current;
        this.total = total;
      });
    },
    detailsQuery(id) {
      this.currentInvoiceId = id;
      this.travelTableVisible = true;
      listDetails(id).then((res) => {
        this.gridData = res.data || [];
      });
    },
    queryInvoiceResult(row, part = "TRANSPORT") {
      if (!row || !row.id) {
        this.$message.error("订单信息不完整");
        return;
      }
      const meta = this.resolveInvoicePartMeta(row, part);
      if (!meta.fpqqlsh) {
        this.$message.warning(`${meta.label}尚未开具`);
        return;
      }
      this.invoiceResultPart = part;
      queryEleInvoiceResult(row.id, part).then((res) => {
        this.invoiceResult = res.data || {};
        this.invoiceResultAuthTip = false;
        this.invoiceResultVisible = true;
        if (this.invoiceResult.fphm) {
          this.$set(row, meta.fphmKey, this.invoiceResult.fphm);
        }
        if (this.invoiceResult.sfych != null && this.invoiceResult.sfych !== "") {
          this.$set(row, meta.sfychKey, this.invoiceResult.sfych === "1");
        }
      });
    },


    resolveInvoicePartMeta(row, part) {
      if (part === "LIFE") {
        return {
          label: "服务票",
          fpqqlsh: row.lifeFpqqlsh,
          fphm: row.lifeFphm,
          sfych: row.lifeSfych,
          fphmKey: "lifeFphm",
          sfychKey: "lifeSfych"
        };
      }
      if (part === "DEFAULT") {
        return {
          label: "默认票",
          fpqqlsh: row.defaultFpqqlsh,
          fphm: row.defaultFphm,
          sfych: row.defaultSfych,
          fphmKey: "defaultFphm",
          sfychKey: "defaultSfych"
        };
      }
      return {
        label: "客运票",
        fpqqlsh: row.fpqqlsh,
        fphm: row.fphm,
        sfych: row.sfych,
        fphmKey: "fphm",
        sfychKey: "sfych"
      };
    },
    hasLifeFees(row) {
      if (!row) {
        return false;
      }
      return (row.seatFee > 0) || (row.changeTimeFee > 0) || (row.refundFee > 0);
    },

    onEleInvoiceAuthRequired(payload) {
      this.loadEleLoginStatus();
      const code = payload && payload.code;
      if (code === "1102") {
        this.openQrAuth();
      }
    },
    resolveSlztText(slzt, fallback) {
      if (slzt === "1") {
        return "未扫码（需实人认证）";
      }
      if (slzt === "2") {
        return "已扫码（认证通过）";
      }
      if (slzt === "3") {
        return "扫码超时";
      }
      if (fallback) {
        return fallback;
      }
      return "待获取二维码";
    },
    openQrAuth(nsrsbh) {
      this.qrNsrsbh = nsrsbh;
      this.invoiceResultVisible = false;
      getEleQrCode({ nsrsbh })
        .then((res) => {
          const data = res.data || {};
          this.qrAuth = Object.assign({}, data, {
            slzt: data.slzt || "1",
            slztText: this.resolveSlztText(data.slzt || "1", data.slztText)
          });
          this.qrAuthVisible = true;
          this.startQrPoll();
        })
        .catch(() => {
          this.$message.error("获取认证二维码失败");
        });
    },
    refreshQrCode() {
      this.clearQrPoll();
      getEleQrCode({ nsrsbh: this.qrNsrsbh }).then((res) => {
        const data = res.data || {};
        this.qrAuth = Object.assign({}, data, {
          slzt: data.slzt || "1",
          slztText: this.resolveSlztText(data.slzt || "1", data.slztText)
        });
        this.startQrPoll();
      });
    },
    startQrPoll() {
      this.clearQrPoll();
      if (!this.qrAuth || !this.qrAuth.rzid) {
        return;
      }
      const rzid = this.qrAuth.rzid;
      this.qrPolling = true;
      this.qrPollTimer = setInterval(() => {
        queryEleQrCodeStatus(rzid)
          .then((res) => {
            const data = res.data || {};
            const slzt = data.slzt || this.qrAuth.slzt;
            // 轮询结果可能不带 rzid，合并时保留本地认证信息，并补全状态文案
            this.qrAuth = Object.assign({}, this.qrAuth, data, {
              rzid: data.rzid || this.qrAuth.rzid || rzid,
              ewm: data.ewm || this.qrAuth.ewm,
              qrImageBase64: data.qrImageBase64 || this.qrAuth.qrImageBase64,
              slzt,
              slztText: this.resolveSlztText(slzt, data.slztText || this.qrAuth.slztText)
            });
            if (slzt === "2") {
              this.clearQrPoll();
              this.$message.success("实人认证成功，请重新开票或查询开票情况");
              this.loadEleLoginStatus();
            } else if (slzt === "3") {
              this.clearQrPoll();
              this.$message.error("扫码超时，请刷新二维码后重试");
            }
          })
          .catch(() => { });
      }, 2000);
    },
    clearQrPoll() {
      this.qrPolling = false;
      if (this.qrPollTimer) {
        clearInterval(this.qrPollTimer);
        this.qrPollTimer = null;
      }
    },
    closeQrAuth() {
      this.clearQrPoll();
      this.qrAuthVisible = false;
    },
    handleIssueFlowResults(list, options = {}) {
      const results = list || [];
      if (!results.length) {
        this.$message.warning("没有可开票记录");
        return;
      }
      const needRelogin = results.find((item) => item.action === "RELOGIN");
      if (needRelogin) {
        this.$message.warning(needRelogin.actionMessage || "需重新登录");
        this.invoiceResult = needRelogin.queryResult || needRelogin.issueResult || {};
        this.invoiceResultAuthTip = true;
        this.invoiceResultVisible = true;
        this.loadEleLoginStatus();
        return;
      }
      const needQr = results.find((item) => item.action === "QR_AUTH");
      if (needQr) {
        const query = needQr.queryResult || needQr.issueResult || {};
        this.invoiceResult = query;
        this.invoiceResultAuthTip = true;
        this.$message.warning(needQr.actionMessage || "需扫码实人认证");
        this.openQrAuth(query.nsrsbh);
        return;
      }
      const successCount = results.filter((item) => item.action === "SUCCESS").length;
      const pendingCount = results.filter((item) => item.action === "PENDING").length;
      const failCount = results.filter((item) => item.action === "FAIL").length;
      if (options.reIssueSend && failCount === 0 && (successCount > 0 || pendingCount > 0)) {
        if (pendingCount > 0) {
          this.$message.success(
            "已提交重新开票，税务出票处理中；出票成功后将自动发送邮件给乘客"
          );
        } else {
          this.$message.success("重新开票成功，将自动发送邮件给乘客");
        }
      } else {
        this.$message.success(
          `开票完成：成功${successCount}，处理中${pendingCount}，失败${failCount}`
        );
      }
      if (results.length === 1 && results[0].queryResult) {
        this.invoiceResult = results[0].queryResult;
        this.invoiceResultAuthTip = false;
        this.invoiceResultVisible = true;
      }
    },
    addReceipt() {
      this.formVisible = true;
      this.form = { invoiceFormats: [] };
    },

    saveOrUpdate() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        if (this.form.id) {
          modifyReceipt(this.form).then(() => {
            this.$message.success("操作成功");
            this.formVisible = false;
            this.query();
          });
        } else {
          addReceipt(this.form).then(() => {
            this.$message.success("操作成功");
            this.formVisible = false;
            this.query();
          });
        }
      });
    },

    closeDialog() {
      this.$refs.form.resetFields();
      this.formVisible = false;
    },

    msgSubmit(item) {
      this.$prompt("请输入留言内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false
      })
        .then(({ value }) => {
          item.msg = value;
          modifyReceipt(item).then(() => {
            this.$message.success("留言成功");
            this.query();
          });
        })
        .catch(() => { });
    },

    upload(item) {
      if (this.$refs.uploadRef && this.$refs.uploadRef.clearFiles) {
        this.$refs.uploadRef.clearFiles();
      }
      this.form = item;
      this.uploadVisible = true;
    },

    onUpload() {
      const formData = new FormData();
      formData.append("id", this.form.id);
      this.files.forEach((file) => {
        formData.append("files", file.raw);
      });
      const url = "/admin/invoice/upload/invoice";
      uploadFiles(url, formData)
        .then(() => {
          this.$message.success("上传成功");
          this.uploadVisible = false;
          this.files = [];
          this.query();
        })
        .catch((error) => {
          console.error("上传出错", error);
        });
    },

    // eslint-disable-next-line no-unused-vars
    handleSuccess(response, file, fileList) {
      this.$message.success("上传成功");
      this.uploadVisible = false;
    },

    // eslint-disable-next-line no-unused-vars
    handleError(err, file, fileList) {
      console.eror(err);
      this.$message.error("发票上传失败");
    },

    // eslint-disable-next-line no-unused-vars
    handleProgress(event, file, fileList) {
      // 可以在这里处理上传进度的逻辑
      console.log("上传进度", event.percent);
    },

    handleChange(file, fileList) {
      this.files = fileList;
    },

    //每页显示的条数
    // handleSizeChange (val) {
    //     //改变每页显示的条数
    //     this.pageSize = val;

    // },
    // 显示第几页
    handleCurrentChange(val) {
      //改变默认的页数
      this.currentPage = val;
      this.query(val);
    },

    handleSelectionChange(val) {
      this.selectOrderIds = val.map((item) => item.id);
    },

    downloadExcel() {
      if (!this.selectOrderIds || !this.selectOrderIds.length) {
        this.$message.error("请勾选要开的发票");
        return;
      }
      downloadFile("/admin/invoice/download/excel", this.selectOrderIds, "发票开票.xlsx");
    },



    reIssueAndSend(row) {
      if (!row || !row.id) {
        return;
      }
      if (!row.email) {
        this.$message.error("没有邮箱，无法重新发送发票");
        return;
      }
      this.$confirm(
        "将冲销原发票并重新开具。提交后税务出票需一定时间，出票成功后会自动发送邮件给乘客，是否继续？",
        "重新开票",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          reIssueAndSendInvoice(row.id).then((res) => {
            this.handleIssueFlowResults(res.data || [], { reIssueSend: true });
            this.loadEleLoginStatus();
            this.query();
          });
        })
        .catch(() => { });
    },

    resendInvoiceMail(row) {
      if (!row || !row.id) {
        return;
      }
      if (!row.email) {
        this.$message.error("没有邮箱，无法重新发送发票");
        return;
      }
      this.$confirm("将重新下载已开具的发票并发送到乘客邮箱，是否继续？", "重新发送", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          resendInvoice(row.id).then(() => {
            this.$message.success("发票已重新发送");
            this.query();
          });
        })
        .catch(() => { });
    },

    modifyInfo(item) {
      this.form = _.cloneDeep(item);
      const formats = (this.form.invoiceFormats || []).map((f) => (f || "").toUpperCase()).filter(Boolean);
      this.$set(this.form, "invoiceFormats", formats);
      this.formVisible = true;
    },

    // 编辑订单
    editOrder(row) {
      // 保存原始数据用于取消编辑
      this.$set(row, "originalData", _.cloneDeep(row));
      this.$set(row, "editing", true);
    },

    // 保存订单修改
    saveOrder(row) {
      // 验证必填字段
      if (!row.number || !row.price) {
        this.$message.error("请填写完整信息");
        return;
      }

      modifyInvoiceOrder(row)
        .then(() => {
          this.$message.success("保存成功");
          this.$set(row, "editing", false);
          this.$delete(row, "originalData");
          // 重新加载订单详情
          this.detailsQuery(this.currentInvoiceId);
        })
        .catch(() => {
          this.$message.error("保存失败");
        });
    },

    // 取消编辑
    cancelEdit(row) {
      if (row.originalData) {
        // 恢复原始数据
        Object.assign(row, row.originalData);
        this.$delete(row, "originalData");
      }
      this.$set(row, "editing", false);
    },

    // 删除订单
    deleteOrder(row) {
      this.$confirm("确定要删除这个订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delInvoiceOrder({ id: row.id })
            .then(() => {
              this.$message.success("删除成功");
              // 重新加载订单详情
              this.detailsQuery(this.currentInvoiceId);
            })
            .catch(() => {
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    },

    showTransaction(id) {
      this.$orderTransaction().show(id);
    }
  }
  //methods
};
</script>

<style scoped lang="less">
.receipt-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
  margin-bottom: 8px;
}

.receipt-filters {
  flex: 1 1 auto;
  min-width: 0;

  /deep/ .el-form-item {
    margin-bottom: 0;
  }
}

.toolbar-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 0 0 auto;
}

.tax-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 4px;
  padding-right: 12px;
  border-right: 1px solid #ebeef5;
}

.table {
  margin: 20px 0;
}

.page {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.result-action-tip {
  margin-top: 12px;
  color: #e6a23c;
  font-size: 13px;
}

.invoice-status-cell {
  font-size: 12px;
  line-height: 1.8;
}

.qr-auth-box {
  text-align: center;
}

.qr-auth-tip {
  margin-bottom: 12px;
  color: #606266;
}

.qr-auth-img {
  width: 260px;
  height: 260px;
  border: 1px solid #ebeef5;
}

.qr-auth-status {
  margin-top: 12px;
}

.qr-auth-sub {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
}

.qr-auth-sub.success-text {
  color: #67c23a;
}

.qr-auth-sub.danger-text {
  color: #f56c6c;
}

.qr-auth-actions {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
